// ============================================================
// PARK HOME SUPPORT (PHS) PLATFORM CONFIGURATION
// Global branding and multi-tenant settings
// ============================================================

export const PLATFORM = {
  name: "Park Home Support",
  shortName: "PHS",
  tagline: "Operations & Maintenance Platform",
  
  // Contact
  email: "advice@parkhomesupport.co.uk",
  supportEmail: "advice@parkhomesupport.co.uk",
  website: "www.parkhomesupport.co.uk",
  
  // Branding
  logo: "/phs-logo.png",
  
  // Colors (Teal theme)
  colors: {
    primary: "#0F766E",
    primaryDark: "#0d6660",
    accent: "#10B981",
  }
};

// ============================================================
// MULTI-TENANT CLIENT CONFIGURATION
// ============================================================

export const CLIENTS = {
  wyldecrest: {
    id: "wyldecrest",
    name: "Wyldecrest Parks",
    shortName: "Wyldecrest",
    domain: "wyldecrest.co.uk",
    branding_key: "wyldecrest",
    type: "client",
  }
};

export const DEFAULT_CLIENT = "wyldecrest";

// ============================================================
// CLIENT CONTEXT HELPERS
// ============================================================

export const getActiveClient = () => {
  return localStorage.getItem('phs_active_client') || DEFAULT_CLIENT;
};

export const setActiveClient = (clientId) => {
  localStorage.setItem('phs_active_client', clientId);
  // Dispatch event for components to react
  window.dispatchEvent(new CustomEvent('phs-client-changed', { detail: { clientId } }));
};

export const getClientConfig = (clientId) => {
  // Always fall back to default if client not found (important after removing clients)
  const client = CLIENTS[clientId];
  if (!client) {
    // Clear invalid client from localStorage
    localStorage.removeItem('phs_active_client');
    return CLIENTS[DEFAULT_CLIENT];
  }
  return client;
};

// ============================================================
// EMAIL TEMPLATES
// ============================================================

export const EMAIL_FOOTER = `
Park Home Support
advice@parkhomesupport.co.uk
Professional Park Home Management
`;

export const SUPPORT_FOOTER = `
---
Need help? Contact Park Home Support
Email: advice@parkhomesupport.co.uk
`;
